export function withAccount(accountId, path = '') {
  const p = path.startsWith('/') ? path.slice(1) : path;
  const first = p.split('/')[0];
  const rest = p.split('/').slice(1).join('/');
  if (first && !isNaN(Number(first))) {
    // Path already contains an accountId
    return `/${accountId}${rest ? `/${rest}` : ''}`;
  }
  return `/${accountId}${p ? `/${p}` : ''}`;
}
